//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Xinput from '@/components/common/x-input.vue'
import {regular} from './config'

    export default {
        data() {
            return {
                modelData:{},
                formList:[]
            }
        },
        props: {
            dataList: {
                type: Array,
                default: ()=>{
                    return []
                }
            },
            defaultData: {
                type: Object,
                default: ()=>{
                    return {}
                }
            }
        },
        components: {
            Xinput
        },
        watch: {
            dataList: {
                deep: true,
                handler(newValue,oldValue){
                    this.formList = newValue
                }
            },
            defaultData: {
                deep: true,
                handler(newValue,oldValue){
                    this.modelData = newValue

                }
            }
        },
        created () {
            this.formList = this.dataList;
            this.modelData = this.defaultData
        },
        methods: {
            inputBlur(item,value) {
                if(value && item.statistic){  //如果值不为空并且有配置埋点
                   item.statistic()
                }
            },
            // 校验
            check(){
                let data = Object.assign({},this.modelData);
                // 不为空判断
                if(this.formList.some((element,index) => {
                    if(!data[element.name] && element.disabled ){ //data中不存在值 并且为必填项
                        this.$toast(element.toastInfo || element.placeholder || '请填写您的'+element.title );
                        // 修改element的verify = valid:true， 展示错误样式  
                        let newelement = Object.assign({},element);
                        newelement.verify = {valid:true}
                        this.$set(this.formList,index,newelement)
                        // --
                        return true; //跳出循环
                    }
                })){
                    return false
                }
                // 不符合规则判断
                if(this.formList.some((element,index) => {
                    if(element.disabled && !regular[element.type](data[element.name])){ //为必填项 并且符合规则 
                        this.$toast('请输入正确的'+element.title );
                        // 修改element的verify = valid:true， 展示错误样式  
                        let newelement = Object.assign({},element);
                        newelement.verify = {valid:true}
                        this.$set(this.formList,index,newelement)
                        // --
                        return true;
                    }
                })){
                    return false
                }
                // 返回校验过的 值
                return  this.modelData
            },
            // 仅获取input内容
            info(){
                let data = Object.assign({},this.modelData);
                console.log(data)
                return data
            }
        },
    }
